import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as envProd from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root',
})
export class EnvConfigService  {

  loadConfig(component: string = 'otro'): Promise<any> {
    const env = environment;
    if (!!env.API_URL) {
      
      return Promise.resolve(env);
    }
    return new Promise((resolve) => {
      fetch('assets/config.json')
      .then((res) => res.json())
      .then((data) => {
        // this.config = data;
        environment.API_URL = data['API_URL'];
        envProd.environment.API_URL = data['API_URL'];
        environment.STORAGE_URL = data['STORAGE_URL'];
        envProd.environment.STORAGE_URL = data['STORAGE_URL'];
        resolve(data);
      });
    });
  }
}
